import { Pipe, PipeTransform } from '@angular/core';
import { StringAnyMap } from 'src/app/core/models/common.models';

@Pipe({
  name: 'craftMapIds',
  standalone: false,
})
export class CraftMapIdsPipe implements PipeTransform {
  public transform(ids?: readonly string[], map?: StringAnyMap, keyUsedAsName = 'name'): string {
    return (ids || [])
      .reduce<string[]>((acc, id) => {
        const name = map?.[id]?.[keyUsedAsName];
        if (name) acc.push(name);
        return acc;
      }, [])
      .join(', ')
      .trim();
  }
}
